import { Component, OnInit } from "@angular/core";

@Component({
    selector: "ec-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.scss"],
    standalone: false
})
export class DashboardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
